import { useState } from "react";
import { CloseOutlined, CheckOutlined, CalendarOutlined } from '@ant-design/icons';
import { Modal, Col, Row, Button, Form, FormInstance, DatePicker, Spin } from 'antd';
import dayjs from 'dayjs';

import { errorMessage, successMessage } from "../../../utils/messages";
import { apiCand } from "../../../services/apiCand";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";
import { IErroApi } from "../../../Interfaces/Interfaces";


interface IProps {
  form: FormInstance<any>,
  botaoVisivel: boolean
}


const TelaDataDeExercicio = ({ form, botaoVisivel }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [exibirModal, setExibirModal] = useState(false);
  const [podeMudarInicio, setPodeMudarInicio] = useState(false);
  
  const [dadosValidados, setDadosValidados] = useState(false);

  const podeMudar = () => {
    if (!botaoVisivel || !hasPermissao([Papel.DILIC_MASTER, Papel.ENTIDADE_ALTERAR]))
      return false;
    if(form.getFieldValue("dtFimExercicio"))
      return false;
    return true;
  }

  const abrirModal = () => {
    setExibirModal(true);
    setPodeMudarInicio(!form.getFieldValue("dtInicioExercicio"))
    form.setFieldsValue({
      "dtInicioExercicioNova": form.getFieldValue("dtInicioExercicio"),
      "dtFimExercicioNova": form.getFieldValue("dtFimExercicio")
    })
  }

  const handleCancel = () => {
    setExibirModal(false);
  };

  const salvarExercicio = () => {
    form.validateFields([
        "dtInicioExercicioNova",
        "dtFimExercicioNova",
    ])
    .then(() => {
        setDadosValidados(true);
        const json = {
          matriculaEfpc: form.getFieldValue("matriculaEfpc"),
          dtInicioExercicio: form.getFieldValue("dtInicioExercicioNova") ? dayjs(form.getFieldValue("dtInicioExercicioNova")).format("YYYY-MM-DD") : "",
          dtFimExercicio: form.getFieldValue("dtFimExercicioNova") ? dayjs(form.getFieldValue("dtFimExercicioNova")).format("YYYY-MM-DD") : ""
        };

        //enviar
        let pagina = '';
        if (window.location.href.includes("conselheiro")){
          pagina = "mandatoconselheiro";
        } else {
          pagina = "mandatodiretor";
        }
        setLoading(true);
        apiCand.patch(`/${pagina}/${form.getFieldValue("idMandato")}/exercicio`, json).then((response) => {
          //atualizar
          successMessage("Data de exercício atualizada com sucesso.");
          form.setFieldsValue({
            "dtInicioExercicio": form.getFieldValue("dtInicioExercicioNova"),
            "dtFimExercicio": form.getFieldValue("dtFimExercicioNova")
          })

          //Fechar modal
          setLoading(false);
          setExibirModal(false);
        })
        .catch((error) => {
          let responsa: IErroApi = error.response.data;
          let msgErro = responsa.mensagem ? responsa.mensagem : error.response.data.message;
          if (error.response.status < 500) {
            let msgDetalheErro = responsa.details ? ". " + responsa.details[0].defaultMessage : "";
            errorMessage(msgErro + msgDetalheErro);
          } else {
            errorMessage(msgErro);
          }
          setLoading(false);
        });
    })
    .catch((error) => {
        if (!dadosValidados) {
          errorMessage("Campo obrigatório não preechido ou não validado");
        } else {
          errorMessage(error.message);
        }
        setDadosValidados(false);
    });

  };

  return (
    <>
      <Button
        style={{ display: podeMudar() ? "inline" : "none" }}
        id="incluirExercicio"
        shape="round"
        onClick={() => {
          abrirModal();
         }}
        icon={<CalendarOutlined />}
      >
        Definir datas de exercício
      </Button>

      <>
        <Modal title="Definir datas de exercício" open={exibirModal}
          style={{ top: 20 }}
          destroyOnHidden={true}
          width={700}
          closable={false}
          footer={[
            <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
              Cancelar
            </Button>,
            <Button icon={<CheckOutlined />} shape="round" key="ok" type="primary" onClick={salvarExercicio}>
              Alterar
            </Button>,
          ]}
        >
          <Spin spinning={loading} tip={tipLoading}>
            <>
              <Row>
                <Col xs={24} sm={8}>
                  <Form.Item label="Data Inicial"
                    name="dtInicioExercicioNova"
                    colon={false}
                    rules={[
                      {
                        required: true,
                        message: "Data inicial obrigatória",
                      },
                      {
                        validator: async (_, startDatetime) => {
                          let dtInicioMandato = form.getFieldValue("dtInicioMandato");
                          if (dtInicioMandato && startDatetime) {
                            startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                            dtInicioMandato = dayjs(dtInicioMandato).format("YYYY-MM-DD")
                            if (startDatetime < dtInicioMandato) {
                              return Promise.reject(
                                "A data não pode ser anterior à Data Inicial do Mandato"
                              );
                            }
                          }
                        },
                      },
                    ]}
                  >
                    <DatePicker
                      format={"DD/MM/YYYY"}
                      style={{ width: "100%" }}
                      placeholder="Selecionar Data"
                      disabled={!podeMudarInicio}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item label="Data Final"
                    name="dtFimExercicioNova"
                    colon={false}
                    rules={[
                      {
                        validator: async (_, endDatetime) => {
                          let startDatetime = form.getFieldValue("dtInicioExercicioNova");
                          if (startDatetime && endDatetime) {
                            endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                            startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                            if (endDatetime < startDatetime) {
                              return Promise.reject(
                                "A Data Final não pode ser anterior à Data Inicial"
                              );
                            }
                          }
                        },
                      },
                      {
                        validator: async (_, endDatetime) => {
                          let dtFimMandato = form.getFieldValue("dtFimMandato");
                          if (dtFimMandato && endDatetime) {
                            endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                            dtFimMandato = dayjs(dtFimMandato).format("YYYY-MM-DD")
                            if (endDatetime > dtFimMandato) {
                              return Promise.reject(
                                "A data não pode ser posterior à Data Final do Mandato"
                              );
                            }
                          }
                        },
                      },
                    ]}
                  >
                    <DatePicker
                      format={"DD/MM/YYYY"}
                      style={{ width: "100%" }}
                      placeholder="Selecionar Data"
                    />
                  </Form.Item>
                </Col>

              </Row>

            </>
          </Spin>
        </Modal>

      </>
    </>
  )
};

export default TelaDataDeExercicio;